import HaspObject from './HaspObject';

export default class HaspTab extends HaspObject {
    // tabview;
    selected = false;

    constructor(config) {
        super(config);
        this.rect.opacity(0);

        this.draggable(false);

        this.on('text_text', () => {
            this.tabview.drawTabs();
        });
    }

    setSize(width, height) {
        this.width(width);
        this.height(height);
        this.rect.width(width);
        this.rect.height(height);
    }

    setSelected(selected) {
        this.selected = selected;
    }

    objectExport(page, objectData) {
        if (this.text) objectData.text = this.text;
    }

}